import { GENERATORS_SELECTED_UPDATE, GENERATORS_SELECTED_CLEAR, GENERATORS_UPDATE, GENERATOR_DATA_CLEAR } from '../reducers/legacy/graphGeneratorData';
export function clearGenerators(graphId) {
  return {
    type: GENERATORS_SELECTED_CLEAR,
    graphId: graphId
  };
}
export function updateGenerators(graphId, generators) {
  return {
    type: GENERATORS_UPDATE,
    graphId: graphId,
    generators: generators
  };
}
export function updateGeneratorSelected(graphId, generatorId, selected) {
  return {
    type: GENERATORS_SELECTED_UPDATE,
    graphId: graphId,
    generatorId: generatorId,
    selected: selected
  };
}
export function clearGeneratorGraphData() {
  return {
    type: GENERATOR_DATA_CLEAR
  };
}